import React, { useState, useEffect, useMemo } from "react";
import "./PlanningTable.css";
import { Col, Row } from "react-bootstrap";
import axios from "axios";
import {
  formatGermanInputForDecimal,
  formatGermanFixedBy2,
} from "../../../utility/NumberFormat";

const PlanningTableNew = (props) => {
  const {
    vkPlanningAllInOneNew,
    paramsData,
    handleChangeForAll,
    handleBlurForAll,
    isEditable,
  } = props;

  const [checkBox_1, setCheckBok1] = useState(true);
  const [checkBox_2, setCheckBok2] = useState(true);
  const [checkBox_3, setCheckBok3] = useState(true);
  const [checkBox_4, setCheckBok4] = useState(true);
  const [checkBox_5, setCheckBok5] = useState(true);
  const [checkBox_6, setCheckBok6] = useState(true);
  const [checkBox_7, setCheckBok7] = useState(true);
  const [checkBox_8, setCheckBok8] = useState(true);
  const [checkBox_9, setCheckBok9] = useState(false);

  // Gesamt Umsatz in VK checkbox
  const showGesamtVK_New_Umsatz = checkBox_1;
  const showGesamtVK_New_Ist = checkBox_6;
  const showGesamtVK_New_UmsatzAnteile = checkBox_1;
  const showGesamtVK_New_PlanWert = checkBox_1;
  const showGesamtVK_New_AbwPlan = checkBox_1;
  const showGesamtVK_New_IstWertVJ = checkBox_6;
  const showGesamtVK_New_IstWertAS400 = checkBox_6;

  const showGesamtVK_New_Section =
    showGesamtVK_New_UmsatzAnteile ||
    showGesamtVK_New_PlanWert ||
    showGesamtVK_New_AbwPlan ||
    showGesamtVK_New_IstWertVJ ||
    showGesamtVK_New_IstWertAS400;

  // WE-Gesamt VK
  const showWEVKPlanColumn = checkBox_9;
  const showWEVKIstColumn = checkBox_9;
  const showWEVKSection = showWEVKPlanColumn || showWEVKIstColumn;

  // WE VK pro Wareneingang
  const showWEVKWareneingangKollektionPlan = checkBox_9;
  const showWEVKWareneingangKollektionIst = checkBox_9;
  const showWEVKWareneingangKollektionAbw = checkBox_9;
  const showWEVKWareneingangNOSPlan = checkBox_9;
  const showWEVKWareneingangNOSIst = checkBox_9;
  const showWEVKWareneingangNOSAbw = checkBox_9;
  const showWEVKWareneingangSection =
    showWEVKWareneingangKollektionPlan ||
    showWEVKWareneingangKollektionIst ||
    showWEVKWareneingangKollektionAbw ||
    showWEVKWareneingangNOSPlan ||
    showWEVKWareneingangNOSIst ||
    showWEVKWareneingangNOSAbw;

  // Limitplan EK Gesamt
  const showLimitNewPercent = checkBox_6;
  const showLimitNewPlanWert = checkBox_6;

  const showLimitNewIstAS400 = checkBox_6;
  const showLimitNewIstVJAS400 = checkBox_6;

  const showLimitNewAbwPlan = checkBox_9;
  const showLimitNewIstMobi = checkBox_9;

  const showLimitNewSection =
    showLimitNewPercent ||
    showLimitNewPlanWert ||
    showLimitNewIstAS400 ||
    showLimitNewIstVJAS400 ||
    showLimitNewAbwPlan ||
    showLimitNewIstMobi;

  // EK Limit pro Wareneingang
  const showEKLimitpro = checkBox_3 || checkBox_6 || checkBox_9;

  const ekLimitProColSpan =
    (checkBox_3 ? 10 : 0) + (checkBox_6 ? 6 : 0) + (checkBox_9 ? 4 : 0);

  // Anfangs-Lagerbestand Gesamt VK
  const showAnfangsLagerPlanWertColumn = checkBox_9;
  const showAnfangsLagerIstWertAS400Column = checkBox_9;
  const showAnfangsLagerAbwPlanColumn = checkBox_9;
  const showAnfangsLagerGesamtVKSection =
    showAnfangsLagerPlanWertColumn ||
    showAnfangsLagerIstWertAS400Column ||
    showAnfangsLagerAbwPlanColumn;

  // Abschriften Gesamt in VK
  const showAbschriftenAnteileColumn = checkBox_5;
  const showAbschriftenPlanWertColumn = checkBox_5;
  const showAbschriftenIstWertAS400Column = checkBox_9;
  const showAbschriftenAbwPlanColumn = checkBox_5;
  const showAbschriftenGesamtVKSection =
    showAbschriftenAnteileColumn ||
    showAbschriftenPlanWertColumn ||
    showAbschriftenIstWertAS400Column ||
    showAbschriftenAbwPlanColumn;

  const authToken = localStorage.getItem("authToken");

  const [apiGetIstDetails, setAPIgetIstDetails] = useState([
    {
      GesamtUmsatz_IsWert_VJ_AS400: "",
      GesamtUmsatz_IsWertAS400: "",
      LimitPlanEkVJIstWertAS400: "",
      LimitPlanEkIstWertAS400: "",
      EKLimitpro_KollektionIstREOWertAS400: "",
      EKLimitpro_NOSIstVOWertAS400: "",
      EKLimitpro_NOSIstREOWertAS400: "",
      EKLimitpro_KollektionIstVOWertAS400: "",
      month: "",
      //checkbox3
      EKlimitProNOSIstAs400Gesamt: "",
      //checkbox4
      AnfangsLagPlanWert: "",
      AnfangsLagIstWertAS400: "",
      AnfangsLagAbwPercentagePlan: "",
      // checkbox5
      Abschriften_GesamtIstWertAS400: "",
      Abschriften_GesamtAbwPercentagePlan: "",
      EKLimitProKollektionIstAS400Gesamt: "",
      NOSIstAS400Gesamt: "",
    },
  ]);

  const lagPlanValues = [];
  const lagPlanValues1 = [];

  const getIstDetails = async () => {
    const selectedSoldTo = paramsData?.soldTo || "";
    const res = await axios.get(
      `${process.env.REACT_APP_API_LINK}/api/v1/entry/getDetailData?soldTo=${selectedSoldTo}&div=${paramsData?.div}&year=${paramsData?.year}&shipTo=${paramsData?.shipTo}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );

    const dataArray = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.data)
        ? res.data.data
        : [];

    const formattedData = dataArray.map((item, index) => {
      return {
        GesamtUmsatz_IsWert_VJ_AS400: item.totalvjvk,
        GesamtUmsatz_IsWertAS400: item?.current_vk,
        LimitPlanEkVJIstWertAS400: item.totalvjek,

        LimitPlanEkIstWertAS400: item?.current_ek,

        EKLimitpro_KollektionIstVOWertAS400:
          item.koll?.vTyp?.["ORDER_BASE_AMOUNT(ek)"],

        EKLimitpro_KollektionIstREOWertAS400:
          item.koll?.rTyp?.["ORDER_BASE_AMOUNT(ek)"],

        EKLimitpro_NOSIstVOWertAS400: item.nos?.vTyp?.["ORDER_BASE_AMOUNT(ek)"],

        EKLimitpro_NOSIstREOWertAS400:
          item.nos?.rTyp?.["ORDER_BASE_AMOUNT(ek)"],
        EKLimitProKollektionIstAS400Gesamt: item?.koll?.totalKoll,
        AnfangsLagPlanWert: lagPlanValues[index] || "",
        AnfangsLagIstWertAS400: lagPlanValues1[index] || "",
        AnfangsLagAbwPercentagePlan: "",
        EKlimitProNOSIstAs400Gesamt: item.nos?.totalNos,
        month: item.monthName,
      };
    });

    setAPIgetIstDetails(formattedData);
  };

  useEffect(() => {
    getIstDetails();
  }, []);

  const getPercentage = (actual, plan) => {
    if (!plan) return "";
    return ((actual - plan) / plan) * 100;
  };

  const buildTableData = (istData, planning) => {
    const dtp = planning?.DTP || [];

    return istData.map((ist, i) => {
      const plan = dtp[i] || {};

      const row = {
        monthName: ist.month,
        ...plan,
        ...ist,
      };

      return {
        ...row,

        AbwPercentagePlan: getPercentage(
          row.GesamtUmsatz_IsWertAS400,
          row.planWert,
        ),

        WEVKproKollektionAbwPercentagePlan: getPercentage(
          row.WEVKproKollektionIstWert,
          row.WEVKproKollektionPlanWert,
        ),

        WEVKproNOSAbwPercentagePlan: getPercentage(
          row.WEVKproNOSIstWert,
          row.WEVKproNOSPlanWert,
        ),

        LimitPlanEkAbwpercentage: getPercentage(
          row.LimitPlanEkIstWertAS400,
          row.LimitplanEKPlanWert,
        ),

        kollektionAbwPercentagePlan: getPercentage(
          row.EKLimitProKollektionIstAS400Gesamt,
          (row.kollNachorderWert || 0) + (row.kollVororderWert || 0),
        ),

        NOSAbwPercentagePlan: getPercentage(
          row.EKlimitProNOSIstAs400Gesamt,
          (row.nosNachorderWert || 0) + (row.nosVororderWert || 0),
        ),

        AnfangsLagAbwPercentagePlan: getPercentage(
          row.AnfangsLagIstWertAS400,
          row.AnfangsLagPlanWert ?? 0,
        ),

        AbschriftenGesamtAbwPercentagePlan: getPercentage(
          row.Abschriften_GesamtIstWertAS400 ?? 0,
          row.planWertAbschriftenGesamt ?? 0,
        ),
      };
    });
  };

  const tableData = useMemo(() => {
    return buildTableData(apiGetIstDetails, vkPlanningAllInOneNew);
  }, [apiGetIstDetails, vkPlanningAllInOneNew]);

  const getCheckvalue = (e) => {
    const { name, checked } = e.target;
    // console.log(name, checked);
    if (name === "checkbox1") {
      setCheckBok1(e.target.checked);
    } else if (name === "checkbox2") {
      setCheckBok2(e.target.checked);
    } else if (name === "checkbox3") {
      setCheckBok3(e.target.checked);
    } else if (name === "checkbox4") {
      setCheckBok4(e.target.checked);
    } else if (name === "checkbox5") {
      setCheckBok5(e.target.checked);
    } else if (name === "checkbox6") {
      setCheckBok6(e.target.checked);
    } else if (name === "checkbox7") {
      setCheckBok7(e.target.checked);
    } else if (name === "checkbox8") {
      setCheckBok8(e.target.checked);
    } else if (name === "checkbox9") {
      setCheckBok9(e.target.checked);
    }
  };

  const sumColumns = (data, keys) => {
    return keys.reduce((acc, key) => {
      const total = data.reduce(
        (sum, row) => sum + (Number(row?.[key]) || 0),
        0,
      );

      acc[key] = total === 0 ? "" : total;

      return acc;
    }, {});
  };

  const totals = useMemo(() => {
    const dtp = vkPlanningAllInOneNew?.DTP || [];
    // console.log("checking Total",dtp)

    return sumColumns(dtp, [
      "umsatzAnteile",
      "planWert",
      "kollVoorderPct",
      "kollVororderWert",
      "kollNachorderPct",
      "kollNachorderWert",
      "nosVororderPct",
      "nosNachorderPct",
      "nosVororderWert",
      "nosNachorderWert",
      "abschriftenAnteilePct",
      "planWertAbschriftenGesamt", //"abschriftenAnteileWert"
      "planWertPct",
      "planWeAmount",
    ]);
  }, [vkPlanningAllInOneNew?.DTP]);

  const sumColumnsParsed = (data, keys, parser) => {
    return keys.reduce((acc, key) => {
      const total = data.reduce(
        (sum, row) => sum + (Number(row?.[key]) || 0),
        0,
      );

      acc[key] = total === 0 ? "" : total;

      return acc;
    }, {});
  };

  const parseGermanNumber = (val) =>
    Number((val || "").toString().replace(/\./g, "").replace(",", ".")) || 0;

  // const istTotals = useMemo(() => {
  //   return sumColumnsParsed(
  //     tableData,
  //     [
  //       "GesamtUmsatz_IsWertAS400",
  //       "GesamtUmsatz_IsWert_VJ_AS400",
  //       "LimitPlanEkVJIstWertAS400",
  //       "EKLimitpro_KollektionIstVOWertAS400",
  //       "EKLimitpro_KollektionIstREOWertAS400",
  //       "EKLimitpro_NOSIstVOWertAS400",
  //       "EKLimitpro_NOSIstREOWertAS400",
  //       "EKLimitProKollektionIstAS400Gesamt",
  //       "AnfangsLagPlanWert",
  //       "AnfangsLagIstWertAS400",
  //       "EKlimitProNOSIstAs400Gesamt",
  //       "LimitPlanEkIstWertAS400",
  //       "AbwPercentagePlan", //not calculating tho
  //       "WEVKproKollektionAbwPercentagePlan",
  //       "WEVKproNOSAbwPercentagePlan",
  //       "LimitPlanEkAbwpercentage",
  //       "kollektionAbwPercentagePlan",
  //       "NOSAbwPercentagePlan",
  //       "AnfangsLagAbwPercentagePlan",
  //       "AbschriftenGesamtAbwPercentagePlan"
  //     ],
  //     parseGermanNumber,
  //   );
  // }, [tableData]);

  const istTotals = useMemo(() => {
    const istSums = sumColumnsParsed(
      tableData,
      [
        "GesamtUmsatz_IsWertAS400",
        "GesamtUmsatz_IsWert_VJ_AS400",
        "LimitPlanEkVJIstWertAS400",
        "EKLimitpro_KollektionIstVOWertAS400",
        "EKLimitpro_KollektionIstREOWertAS400",
        "EKLimitpro_NOSIstVOWertAS400",
        "EKLimitpro_NOSIstREOWertAS400",
        "EKLimitProKollektionIstAS400Gesamt",
        "AnfangsLagPlanWert",
        "AnfangsLagIstWertAS400",
        "EKlimitProNOSIstAs400Gesamt",
        "LimitPlanEkIstWertAS400",

        // "AbwPercentagePlan", //not calculating tho
        "WEVKproKollektionAbwPercentagePlan",
        "WEVKproNOSAbwPercentagePlan",

        "LimitPlanEkAbwpercentage",
        // "kollektionAbwPercentagePlan",
        // "NOSAbwPercentagePlan",
        "AnfangsLagAbwPercentagePlan",
        // "AbschriftenGesamtAbwPercentagePlan",
        "Abschriften_GesamtIstWertAS400",
      ],
      parseGermanNumber,
    );

    return {
      ...istSums,

      AbwPercentagePlan: getPercentage(
        istSums.GesamtUmsatz_IsWertAS400,
        totals.planWert,
      ),
      kollektionAbwPercentagePlan: getPercentage(
        istSums.EKLimitProKollektionIstAS400Gesamt,
        (totals.kollNachorderWert || 0) + (totals.kollVororderWert || 0),
      ),
      NOSAbwPercentagePlan: getPercentage(
        istSums.EKlimitProNOSIstAs400Gesamt,
        (totals.nosNachorderWert || 0) + (totals.nosVororderWert || 0),
      ),
      AbschriftenGesamtAbwPercentagePlan:getPercentage(
          istSums.Abschriften_GesamtIstWertAS400 || 0,
          totals.planWertAbschriftenGesamt ?? 0,
        ),

      // etc...
    };
  }, [tableData]);

  // console.log("IST sample", apiGetIstDetails);
  // console.log("vkPlanningAllInOneNew from planning table", vkPlanningAllInOneNew);
  // console.log("Merged row", tableData);
  // console.log("totals ", totals);
  // console.log("ist totals", istTotals);
  // console.log('vk planning new', vkPlanningAllInOneNew)

  // Abw Percentage value calculation

  // checked unchecked useEffect
  // useEffect(() => {
  //   if (checkBox_9) {
  //     setCheckBok8(false);
  //   }
  // }, [checkBox_9])

  // const nos

  return (
    <div className="border rounded bg-white w-100">
      <div className="vkPlanning-allCheckBox_main">
        <Row className="">
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox1"
                checked={checkBox_1}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">Gesamt Umsatz in VK</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox8"
                checked={checkBox_8}
                onChange={getCheckvalue}
                disabled
              />
            </div>
            <div className="checkbox_text"> WE-Gesamt VK</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox7"
                checked={checkBox_7}
                onChange={getCheckvalue}
                disabled
              />
            </div>
            <div className="checkbox_text"> WE VK pro Wareneingang</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox2"
                checked={checkBox_2}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">Limitplan EK Gesamt</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox3"
                checked={checkBox_3}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">EK Limit pro Wareneingang</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox4"
                checked={checkBox_4}
                onChange={getCheckvalue}
                disabled
              />
            </div>
            <div className="checkbox_text">Anfangs-Lagerbestand Gesamt VK</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox5"
                checked={checkBox_5}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">Abschriften Gesamt in VK</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox6"
                checked={checkBox_6}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">Ist</div>
          </Col>
          <Col className="allCheckBox">
            <div className="checkbox_input">
              <input
                type="checkbox"
                name="checkbox9"
                checked={checkBox_9}
                onChange={getCheckvalue}
              />
            </div>
            <div className="checkbox_text">Not In Use</div>
          </Col>
        </Row>
      </div>
      <div className="planningTableContainerMain">
        <table className="planning_table_data">
          <thead>
            <tr className="table_th">
              <th className="table_subheader" rowSpan={2}>
                Monat
              </th>
              {showGesamtVK_New_Section && (
                <th
                  className="table_subheader"
                  colSpan={
                    (showGesamtVK_New_UmsatzAnteile ? 1 : 0) +
                    (showGesamtVK_New_PlanWert ? 1 : 0) +
                    (showGesamtVK_New_AbwPlan ? 1 : 0) +
                    (showGesamtVK_New_IstWertVJ ? 1 : 0) +
                    (showGesamtVK_New_IstWertAS400 ? 1 : 0)
                  }
                >
                  Gesamt Umsatz in VK
                </th>
              )}
              {showWEVKSection && (
                <th
                  className="table_subheader unused"
                  colSpan={
                    (showWEVKPlanColumn ? 1 : 0) + (showWEVKIstColumn ? 1 : 0)
                  }
                >
                  WE-Gesamt VK
                </th>
              )}
              {showWEVKWareneingangSection && (
                <th
                  className="table_subheader unused"
                  colSpan={
                    (showWEVKWareneingangKollektionPlan ? 1 : 0) +
                    (showWEVKWareneingangKollektionIst ? 1 : 0) +
                    (showWEVKWareneingangKollektionAbw ? 1 : 0) +
                    (showWEVKWareneingangNOSPlan ? 1 : 0) +
                    (showWEVKWareneingangNOSIst ? 1 : 0) +
                    (showWEVKWareneingangNOSAbw ? 1 : 0)
                  }
                >
                  WE VK pro Wareneingang
                </th>
              )}
              {showLimitNewSection && (
                <th
                  className="table_subheader unused"
                  colSpan={
                    (showLimitNewPercent ? 1 : 0) +
                    (showLimitNewPlanWert ? 1 : 0) +
                    (showLimitNewIstAS400 ? 1 : 0) +
                    (showLimitNewAbwPlan ? 1 : 0) +
                    (showLimitNewIstVJAS400 ? 1 : 0) +
                    (showLimitNewIstMobi ? 1 : 0)
                  }
                >
                  Limitplan EK Gesamt
                </th>
              )}
              {ekLimitProColSpan > 0 && (
                <th
                  colSpan={ekLimitProColSpan}
                  className="table_subheader unused"
                >
                  EK Limit pro Wareneingang
                </th>
              )}

              {showAnfangsLagerGesamtVKSection && (
                <th
                  className="table_subheader unused"
                  colSpan={
                    (showAnfangsLagerPlanWertColumn ? 1 : 0) +
                    (showAnfangsLagerIstWertAS400Column ? 1 : 0) +
                    (showAnfangsLagerAbwPlanColumn ? 1 : 0)
                  }
                >
                  Anfangs-Lagerbestand Gesamt VK
                </th>
              )}

              {showAbschriftenGesamtVKSection && (
                <th
                  className="table_subheader unused"
                  colSpan={
                    (showAbschriftenAnteileColumn ? 1 : 0) +
                    (showAbschriftenPlanWertColumn ? 1 : 0) +
                    (showAbschriftenIstWertAS400Column ? 1 : 0) +
                    (showAbschriftenAbwPlanColumn ? 1 : 0)
                  }
                >
                  Abschriften Gesamt in VK
                </th>
              )}
            </tr>
            <tr className="table_subheader">
              {showGesamtVK_New_Section && (
                <>
                  {showGesamtVK_New_IstWertVJ && (
                    <th>
                      Ist-Wert VJ
                      <br />
                      AS400
                    </th>
                  )}

                  {showGesamtVK_New_UmsatzAnteile && (
                    <th>
                      <div>Umsatz</div>
                      <div>Anteile in %</div>
                    </th>
                  )}

                  {showGesamtVK_New_PlanWert && <th>Plan Wert</th>}

                  {showGesamtVK_New_IstWertAS400 && (
                    <th>
                      Ist-Wert
                      <br />
                      AS400
                    </th>
                  )}

                  {showGesamtVK_New_AbwPlan && (
                    <th>
                      Abw. %
                      <br />
                      Plan
                    </th>
                  )}
                </>
              )}

              {showWEVKSection && (
                <>
                  {showWEVKPlanColumn && (
                    <th>
                      <div>Plan Wert</div>
                      <div>WE VK</div>
                    </th>
                  )}

                  {showWEVKIstColumn && (
                    <th>
                      Ist-Wert
                      <br />
                      AS400
                    </th>
                  )}
                </>
              )}

              {showWEVKWareneingangSection && (
                <>
                  {showWEVKWareneingangKollektionPlan && (
                    <th>
                      Kollektion
                      <br />
                      Plan Wert
                    </th>
                  )}

                  {showWEVKWareneingangKollektionIst && (
                    <th>
                      Kollektion
                      <br />
                      Ist Wert
                    </th>
                  )}

                  {showWEVKWareneingangKollektionAbw && (
                    <th>
                      Kollektion
                      <br />
                      Abw.%
                      <br />
                      Plan
                    </th>
                  )}

                  {showWEVKWareneingangNOSPlan && (
                    <th>
                      NOS Plan
                      <br />
                      Wert
                    </th>
                  )}

                  {showWEVKWareneingangNOSIst && (
                    <th>
                      NOS
                      <br />
                      Ist Wert
                    </th>
                  )}

                  {showWEVKWareneingangNOSAbw && (
                    <th>
                      NOS
                      <br />
                      Abw.%
                      <br />
                      Plan
                    </th>
                  )}
                </>
              )}

              {showLimitNewSection && (
                <>
                  {showLimitNewPercent && <th>%</th>}

                  {showLimitNewPlanWert && <th>Plan Wert</th>}

                  {showLimitNewIstAS400 && (
                    <th>
                      Ist-Wert <br />
                      AS400
                    </th>
                  )}

                  {showLimitNewAbwPlan && <th>Abw % Plan</th>}

                  {showLimitNewIstVJAS400 && (
                    <th>
                      Ist-Wert VJ <br />
                      AS400
                    </th>
                  )}

                  {showLimitNewIstMobi && (
                    <th>
                      Ist-Wert <br />
                      Mobi
                    </th>
                  )}
                </>
              )}

              {showEKLimitpro ? (
                <>
                  {checkBox_3 && (
                    <>
                      <th>
                        Kollektion %<br /> Plan VO <br /> Wert
                      </th>
                      <th>
                        Kollektion
                        <br /> Plan VO <br />
                        Wert
                      </th>
                    </>
                  )}
                  {checkBox_9 && (
                    <>
                      <th>
                        Kollektion %<br /> Plan REO <br />
                        Wert
                      </th>
                      <th>
                        Kollektion <br /> Plan REO <br />
                        Wert
                      </th>
                    </>
                  )}
                  {checkBox_3 && (
                    <>
                      <th>
                        Kollektion <br /> Plan
                        <br />
                        Gesamt
                      </th>
                    </>
                  )}

                  {checkBox_9 && (
                    <th>
                      Kollektion Ist <br /> VO Wert<br></br> Mobi
                    </th>
                  )}

                  {checkBox_6 && (
                    <>
                      <th>
                        Kollektion Ist <br /> VO Wert AS400
                      </th>
                      <th>
                        Kollektion Ist <br />
                        REO Wert
                        <br /> AS400
                      </th>
                      <th>
                        Kollektion Ist
                        <br /> AS400
                        <br />
                        Gesamt
                      </th>
                    </>
                  )}

                  {checkBox_3 && (
                    <>
                      <th>
                        Kollektion <br />
                        Abw. %<br /> Plan
                      </th>
                      <th>
                        NOS % Plan <br />
                        VO Wert
                      </th>
                      <th>
                        NOS Plan VO
                        <br /> Wert
                      </th>
                      <th>
                        NOS % Plan
                        <br /> REO Wert
                      </th>
                      <th>
                        NOS Plan
                        <br /> REO Wert
                      </th>
                      <th>
                        NOS Plan
                        <br /> Gesamt
                      </th>
                    </>
                  )}

                  {checkBox_9 && (
                    <th>
                      NOS Ist VO <br />
                      Wert Mobi
                    </th>
                  )}

                  {checkBox_6 && (
                    <>
                      <th>
                        NOS Ist VO
                        <br /> Wert AS400
                      </th>
                      <th>
                        NOS Ist REO
                        <br /> Wert AS400
                      </th>
                      <th>
                        NOS Ist
                        <br /> AS400
                        <br /> Gesamt
                      </th>
                    </>
                  )}

                  {checkBox_3 && (
                    <th>
                      NOS
                      <br /> Abw. %<br /> Plan
                    </th>
                  )}
                </>
              ) : null}

              {showAnfangsLagerGesamtVKSection && (
                <>
                  {showAnfangsLagerPlanWertColumn && <th>Plan Wert</th>}

                  {showAnfangsLagerIstWertAS400Column && (
                    <th>
                      Ist-Wert
                      <br />
                      AS400
                    </th>
                  )}

                  {showAnfangsLagerAbwPlanColumn && <th>Abw.% Plan</th>}
                </>
              )}

              {showAbschriftenGesamtVKSection && (
                <>
                  {showAbschriftenAnteileColumn && (
                    <th>
                      Abschriften
                      <br />
                      Anteile %
                    </th>
                  )}

                  {showAbschriftenPlanWertColumn && <th>Plan Wert</th>}

                  {showAbschriftenIstWertAS400Column && (
                    <th>
                      Ist-Wert
                      <br />
                      AS400
                    </th>
                  )}

                  {showAbschriftenAbwPlanColumn && <th>Abw. % Plan</th>}
                </>
              )}
            </tr>
          </thead>
          <tbody className="planning_table_body">
            {tableData?.map((data, index) => (
              <tr className="planning_table_body_tr" key={index}>
                <td
                  className="table_body_td_month"
                  style={{ textAlign: "left" }}
                >
                  {data?.month}
                </td>
                {showGesamtVK_New_Section && (
                  <>
                    {showGesamtVK_New_IstWertVJ && (
                      <td>
                        <input
                          autoComplete="off"
                          name="GesamtUmsatz_IsWert_VJ_AS400"
                          // value={
                          //   formatGermanInputForDecimal(
                          //     Math.round(data?.GesamtUmsatz_IsWertAS400),
                          //   ) ?? ""
                          // }
                          value={
                            formatGermanInputForDecimal(
                              Math.round(data?.GesamtUmsatz_IsWert_VJ_AS400),
                            ) ?? ""
                          }
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            // border: "1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showGesamtVK_New_UmsatzAnteile && (
                      <td>
                        <input
                          autoComplete="off"
                          name="umsatzAnteile"
                          // value={
                          //   formatGermanInputForDecimal(
                          //     Math.round(data?.GesamtUmsatz_IsWert_VJ_AS400),
                          //   ) ?? ""
                          // }
                          value={
                            formatGermanFixedBy2(
                              vkPlanningAllInOneNew?.DTP[index]?.umsatzAnteile,
                              1,
                              1,
                              true,
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}

                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            textAlign: "right",
                            border:
                              index % 2 === 0
                                ? "1px solid #d4ecfb"
                                : "1px solid white",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showGesamtVK_New_PlanWert && (
                      <td>
                        <input
                          autoComplete="off"
                          name="planWert"
                          // value={
                          //   formatGermanFixedBy2(
                          //     vkPlanningAllInOneNew?.DTP[index]
                          //       ?.umsatzAnteile
                          //   ) || ""
                          // }
                          value={
                            formatGermanInputForDecimal(
                              Math.round(
                                vkPlanningAllInOneNew?.DTP[index]?.planWert,
                              ),
                              true,
                            ) ?? ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #d4ecfb"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          // maxLength={3}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}

                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showGesamtVK_New_IstWertAS400 && (
                      <td>
                        <input
                          autoComplete="off"
                          name="GesamtUmsatz_IsWertAS400"
                          value={
                            formatGermanInputForDecimal(
                              Math.round(data?.GesamtUmsatz_IsWertAS400),
                            ) ?? ""
                          }
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: "1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showGesamtVK_New_AbwPlan && (
                      <td>
                        <input
                          autoComplete="off"
                          name="AbwPercentagePlan"
                          // value={
                          //   formatGermanInputForDecimal(
                          //     Math.round(
                          //       vkPlanningAllInOneNew?.DTP[index]?.planWert,
                          //     ),
                          //   ) ?? ""
                          // }
                          value={formatGermanFixedBy2(data?.AbwPercentagePlan)}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          // disabled

                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}

                {showWEVKSection && (
                  <>
                    {showWEVKPlanColumn && (
                      <td>
                        <input
                          // className="unused"
                          autoComplete="off"
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {showWEVKIstColumn && (
                      <td>
                        <input
                          // className="unused"
                          autoComplete="off"
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: "1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}

                {showWEVKWareneingangSection && (
                  <>
                    {showWEVKWareneingangKollektionPlan && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="WEVKproKollektionPlanWert"
                          value={data?.WEVKproKollektionPlanWert || ""}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {showWEVKWareneingangKollektionIst && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="WEVKproKollektionIstWert"
                          value={data?.WEVKproKollektionIstWert || ""}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {/* {showKollektionAbw && (
                      <> */}
                    {showWEVKWareneingangKollektionAbw && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="WEVKproKollektionAbwPercentagePlan"
                          value={formatGermanInputForDecimal(
                            data?.WEVKproKollektionAbwPercentagePlan,
                          )}
                          // onChange={(e) =>
                          //   handleChangeForAll("DTP", e, index)
                          // }
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showWEVKWareneingangNOSPlan && (
                      <td>
                        <input
                          className="unused"
                          name="WEVKproNOSPlanWert"
                          value={data?.WEVKproNOSPlanWert || ""}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          autoComplete="off"
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {/* </>
                    )} */}

                    {showWEVKWareneingangNOSIst && (
                      <td>
                        <input
                          className="unused"
                          name="WEVKproNOSIstWert"
                          value={data?.WEVKproNOSIstWert || ""}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          autoComplete="off"
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showWEVKWareneingangNOSAbw && (
                      <td>
                        <input
                          className="unused"
                          name="WEVKproNOSAbwPercentagePlan"
                          value={formatGermanInputForDecimal(
                            data?.WEVKproNOSAbwPercentagePlan,
                          )}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          autoComplete="off"
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}

                {showLimitNewSection && (
                  <>
                    {showLimitNewPercent && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="planWertPct"
                          // value={data?.LimitplanEKpercentage || ""}
                          value={formatGermanFixedBy2(data?.planWertPct,1 ,1, true) || ""}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            border:
                              index % 2 === 0
                                ? " 1px solid #d4ecfb"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly
                        />
                      </td>
                    )}
                    {showLimitNewPlanWert && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="planWeAmount"
                          // value={data?.LimitplanEKPlanWert || ""}
                          value={formatGermanInputForDecimal(Math.round(data?.planWeAmount)) || ""}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            border:
                              index % 2 === 0
                                ? " 1px solid #d4ecfb"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly
                        />
                      </td>
                    )}

                    {showLimitNewIstAS400 && (
                      <td>
                        <input
                          autoComplete="off"
                          name="LimitPlanEkIstWertAS400"
                          value={
                            formatGermanInputForDecimal(
                              Math.round(data?.LimitPlanEkIstWertAS400),
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {showLimitNewAbwPlan && (
                      <td>
                        <input
                          className="unused"
                          name="LimitPlanEkAbwpercentage"
                          // value={data?.LimitPlanEkAbwpercentage}
                          value={formatGermanInputForDecimal(
                            data?.LimitPlanEkAbwpercentage,
                          )}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          autoComplete="off"
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {showLimitNewIstVJAS400 && (
                      <td>
                        <input
                          autoComplete="off"
                          name="LimitPlanEkVJIstWertAS400"
                          value={
                            formatGermanInputForDecimal(
                              Math.round(data?.LimitPlanEkVJIstWertAS400),
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {showLimitNewIstMobi && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}

                {showEKLimitpro ? (
                  <>
                    {checkBox_3 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollVoorderPct"
                            value={
                              formatGermanFixedBy2(
                                data?.kollVoorderPct,
                                1,
                                1,
                                true,
                              ) || ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollVororderWert"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.kollVororderWert),
                                true,
                              ) ?? ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}
                    {checkBox_9 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollNachorderPct"
                            value={
                              formatGermanFixedBy2(
                                data?.kollNachorderPct,
                                1,
                                1,
                                true,
                              ) ?? ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollNachorderWert"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.kollNachorderWert),
                                true,
                              ) ?? ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}
                    {checkBox_3 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollektionPlanGesamt"
                            // value={data?.kollektionPlanGesamt || ""}
                            value={formatGermanInputForDecimal(
                              data?.kollNachorderWert +
                                Math.round(data?.kollVororderWert),
                            )}
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#dddddd" : "white",
                              border:
                                index % 2 === 0
                                  ? "1px solid #dddddd"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}

                    {checkBox_9 && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="kollektionIstVOWertMobi"
                          value={data?.kollektionIstVOWertMobi || ""}
                          // onChange={(e) =>
                          //   handleChangeForAll("DTP", e, index)
                          // }
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {checkBox_6 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKLimitpro_KollektionIstVOWertAS400"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(
                                  data?.EKLimitpro_KollektionIstVOWertAS400,
                                ),
                              ) ?? ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKLimitpro_KollektionIstREOWertAS400"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(
                                  data?.EKLimitpro_KollektionIstREOWertAS400,
                                ),
                              ) || ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKLimitProKollektionIstAS400Gesamt"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(
                                  data?.EKLimitProKollektionIstAS400Gesamt,
                                ),
                              ) || ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}

                    {checkBox_3 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="kollektionAbwPercentagePlan"
                            // value={data?.kollektionAbwPercentagePlan || ""}
                            // value={
                            //   data?.kollektionPlanGesamt
                            //     ? (
                            //       (data?.EKLimitProKollektionIstAS400Gesamt - data?.kollektionPlanGesamt) /
                            //       data?.kollektionPlanGesamt
                            //     ) * 100
                            //     : 0
                            // }
                            value={formatGermanFixedBy2(
                              data?.kollektionAbwPercentagePlan || "",
                            )}
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#dddddd" : "white",
                              border:
                                index % 2 === 0
                                  ? "1px solid #dddddd"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="nosVororderPct"
                            value={
                              formatGermanFixedBy2(
                                data?.nosVororderPct,
                                1,
                                1,
                                true,
                              ) || ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="nosVororderWert"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.nosVororderWert),
                                true,
                              ) || ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="nosNachorderPct"
                            value={
                              formatGermanFixedBy2(
                                data?.nosNachorderPct,
                                1,
                                1,
                                true,
                              ) ?? ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="nosNachorderWert"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.nosNachorderWert),
                                true,
                              ) ?? ""
                            }
                            onChange={(e) =>
                              handleChangeForAll("DTP", e, index)
                            }
                            onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#d4ecfb" : "white",
                              border:
                                index % 2 === 0
                                  ? " 1px solid #d4ecfb"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="NOSPlanGesamt"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.nosNachorderWert) +
                                  Math.round(data?.nosVororderWert),
                              ) || ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: index % 2 === 0 ? "#dddddd" : "white",
                              border:
                                index % 2 === 0
                                  ? "1px solid #dddddd"
                                  : "1px solid white",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}

                    {checkBox_9 && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="NOSIstVOWertMobi"
                          value={data?.NOSIstVOWertMobi || ""}
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}

                    {checkBox_6 && (
                      <>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKLimitpro_NOSIstVOWertAS400"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(
                                  data?.EKLimitpro_NOSIstVOWertAS400 || "",
                                ),
                              ) || ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKLimitpro_NOSIstREOWertAS400"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(
                                  data?.EKLimitpro_NOSIstREOWertAS400 || "",
                                ),
                              ) || ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                        <td>
                          <input
                            autoComplete="off"
                            name="EKlimitProNOSIstAs400Gesamt"
                            value={
                              formatGermanInputForDecimal(
                                Math.round(data?.EKlimitProNOSIstAs400Gesamt),
                              ) || ""
                            }
                            // onChange={(e) =>
                            //   handleChangeForAll("DTP", e, index)
                            // }
                            // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                            style={{
                              background: "rgb(247, 246, 215)",
                              border: " 1px solid rgb(247, 246, 215)",
                              textAlign: "right",
                            }}
                            readOnly={isEditable === false}
                          />
                        </td>
                      </>
                    )}

                    {checkBox_3 && (
                      <td>
                        <input
                          autoComplete="off"
                          name="NOSAbwPercentagePlan"
                          // value={data?.NOSAbwPercentagePlan || ""}
                          value={formatGermanFixedBy2(
                            data?.NOSAbwPercentagePlan || "",
                          )}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                ) : null}
                {/*  */}

                {showAnfangsLagerGesamtVKSection && (
                  <>
                    {showAnfangsLagerPlanWertColumn && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="AnfangsLagPlanWert"
                          value={
                            formatGermanInputForDecimal(
                              data?.AnfangsLagPlanWert,
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showAnfangsLagerIstWertAS400Column && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="AnfangsLagIstWertAS400"
                          value={
                            formatGermanInputForDecimal(
                              data?.AnfangsLagIstWertAS400,
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showAnfangsLagerAbwPlanColumn && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="AnfangsLagAbwPercentagePlan"
                          // value={formatGermanInputForDecimal(data?.AnfangsLagAbwPercentagePlan) || ""}
                          // value={data?.AnfangsLagIstWertAS400-data?.AnfangsLagPlanWert/data?.AnfangsLagPlanWert*100}
                          value={formatGermanInputForDecimal(
                            data?.AnfangsLagAbwPercentagePlan,
                          )}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}
                {/*  */}
                {showAbschriftenGesamtVKSection && (
                  <>
                    {showAbschriftenAnteileColumn && (
                      <td>
                        <input
                          autoComplete="off"
                          name="abschriftenAnteilePct"
                          value={
                            formatGermanFixedBy2(
                              data?.abschriftenAnteilePct,
                              1,
                              1,
                              true,
                            ) ?? ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            border:
                              index % 2 === 0
                                ? " 1px solid #d4ecfb"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showAbschriftenPlanWertColumn && (
                      <td>
                        <input
                          autoComplete="off"
                          name="planWertAbschriftenGesamt"
                          value={
                            formatGermanInputForDecimal(
                              Math.round(data?.planWertAbschriftenGesamt),
                              true,
                            ) ?? ""
                          }
                          // value={5}
                          // onChange={(e) =>
                          //   handleChangeForAll("DTP", e, index)
                          // }
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#d4ecfb" : "white",
                            border:
                              index % 2 === 0
                                ? " 1px solid #d4ecfb"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showAbschriftenIstWertAS400Column && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="Abschriften_GesamtIstWertAS400"
                          value={
                            formatGermanInputForDecimal(
                              data?.Abschriften_GesamtIstWertAS400,
                            ) || ""
                          }
                          onChange={(e) => handleChangeForAll("DTP", e, index)}
                          onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: "rgb(247, 246, 215)",
                            border: " 1px solid rgb(247, 246, 215)",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                    {showAbschriftenAbwPlanColumn && (
                      <td>
                        <input
                          className="unused"
                          autoComplete="off"
                          name="AbschriftenGesamtAbwPercentagePlan"
                          value={formatGermanFixedBy2(
                            data?.AbschriftenGesamtAbwPercentagePlan,
                          )}
                          // onChange={(e) => handleChangeForAll("DTP", e, index)}
                          // onBlur={(e) => handleBlurForAll("DTP", e, index)}
                          style={{
                            background: index % 2 === 0 ? "#dddddd" : "white",
                            border:
                              index % 2 === 0
                                ? "1px solid #dddddd"
                                : "1px solid white",
                            textAlign: "right",
                          }}
                          readOnly={isEditable === false}
                        />
                      </td>
                    )}
                  </>
                )}
              </tr>
            ))}

            <tr className="planning_table_body_tr_total">
              <td
                className="planning_table_total_header_child"
                style={{ textAlign: "left" }}
              >
                Gesamt
              </td>
              {showGesamtVK_New_Section && (
                <>
                  {showGesamtVK_New_IstWertVJ && (
                    <td className="planning_table_total_child">
                      {/* {formatGermanInputForDecimal(
                        Math.round(istTotals?.GesamtUmsatz_IsWertAS400)
                      )} */}
                      {formatGermanInputForDecimal(
                        Math.round(istTotals?.GesamtUmsatz_IsWert_VJ_AS400),
                      )}
                    </td>
                  )}
                  {showGesamtVK_New_UmsatzAnteile && (
                    <td className="planning_table_total_child">
                      {formatGermanFixedBy2(
                        totals?.umsatzAnteile,
                        1,
                        1,
                        true,
                      ) || ""}
                    </td>
                  )}

                  {showGesamtVK_New_PlanWert && (
                    <td className="planning_table_total_child">
                      {formatGermanInputForDecimal(totals?.planWert)}
                    </td>
                  )}
                  {showGesamtVK_New_IstWertAS400 && (
                    <td className="planning_table_total_child">
                      {formatGermanInputForDecimal(
                        Math.round(istTotals?.GesamtUmsatz_IsWertAS400),
                      )}
                    </td>
                  )}
                  {showGesamtVK_New_AbwPlan && (
                    <td className="planning_table_total_child">
                      {/* <div className="planning_table_total_child-inside"> */}
                      {formatGermanFixedBy2(istTotals?.AbwPercentagePlan || "")}
                      {/* </div> */}
                    </td>
                  )}
                </>
              )}

              {showWEVKSection && (
                <>
                  {showWEVKPlanColumn && (
                    <td className="planning_table_total_child unused"></td>
                  )}

                  {showWEVKIstColumn && (
                    <td className="planning_table_total_child unused"></td>
                  )}
                </>
              )}

              {showWEVKWareneingangSection && (
                <>
                  {showWEVKWareneingangKollektionPlan && (
                    <td className="planning_table_total_child unused">
                      {totals?.tot_WEVKproKollektionPlanWert || ""}
                    </td>
                  )}

                  {showWEVKWareneingangKollektionIst && (
                    <td className="planning_table_total_child unused">
                      {totals?.tot_WEVKproKollektionIstWert || ""}
                    </td>
                  )}

                  {showWEVKWareneingangKollektionAbw && (
                    <td className="planning_table_total_child unused">
                      {istTotals?.WEVKproKollektionAbwPercentagePlan || ""}
                    </td>
                  )}

                  {showWEVKWareneingangNOSPlan && (
                    <td className="planning_table_total_child unused">
                      {totals?.tot_WEVKproNOSPlanWert || ""}
                    </td>
                  )}

                  {showWEVKWareneingangNOSIst && (
                    <td className="planning_table_total_child unused">
                      {totals?.tot_WEVKproNOSIstWert || ""}
                    </td>
                  )}

                  {showWEVKWareneingangNOSAbw && (
                    <td className="planning_table_total_child unused">
                      {istTotals?.WEVKproNOSAbwPercentagePlan || ""}
                    </td>
                  )}
                </>
              )}

              {showLimitNewSection && (
                <>
                  {showLimitNewPercent && (
                    <td className="planning_table_total_child unused">
                      {formatGermanFixedBy2(totals?.planWertPct) || ""}
                    </td>
                  )}

                  {showLimitNewPlanWert && (
                    <td className="planning_table_total_child unused">
                      {formatGermanInputForDecimal(
                        Math.round(totals?.planWeAmount) || "",
                      )}
                    </td>
                  )}

                  {showLimitNewIstAS400 && (
                    <td className="planning_table_total_child">
                      {formatGermanInputForDecimal(
                        Math.round(istTotals?.LimitPlanEkIstWertAS400),
                      ) || ""}
                    </td>
                  )}

                  {showLimitNewAbwPlan && (
                    <td className="planning_table_total_child unused">
                      {istTotals?.LimitPlanEkAbwpercentage || ""}
                    </td>
                  )}

                  {showLimitNewIstVJAS400 && (
                    <td className="planning_table_total_child">
                      {formatGermanInputForDecimal(
                        Math.round(istTotals?.LimitPlanEkVJIstWertAS400),
                      )}
                    </td>
                  )}

                  {showLimitNewIstMobi && (
                    <td className="planning_table_total_child unused"></td>
                  )}
                </>
              )}

              {showEKLimitpro ? (
                <>
                  {checkBox_3 && (
                    <>
                      <td className="planning_table_total_child">
                        {formatGermanFixedBy2(totals?.kollVoorderPct) || ""}
                      </td>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(
                          Math.round(totals?.kollVororderWert),
                        )}
                        {/* </div> */}
                      </td>
                    </>
                  )}
                  {checkBox_9 && (
                    <>
                      <td className="planning_table_total_child">
                        {formatGermanFixedBy2(totals?.kollNachorderPct) ?? ""}
                      </td>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(totals?.kollNachorderWert)}
                        {/* </div> */}
                      </td>
                    </>
                  )}
                  {checkBox_3 && (
                    <>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(
                          Math.round(totals?.kollVororderWert) +
                            Math.round(totals?.kollNachorderWert),
                        )}
                        {/* </div> */}
                      </td>
                    </>
                  )}

                  {checkBox_9 && (
                    <td className="planning_table_total_child unused"></td>
                  )}

                  {checkBox_6 && (
                    <>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          Math.round(
                            istTotals?.EKLimitpro_KollektionIstVOWertAS400,
                          ),
                        )}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          Math.round(
                            istTotals?.EKLimitpro_KollektionIstREOWertAS400,
                          ),
                        )}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          Math.round(
                            istTotals?.EKLimitProKollektionIstAS400Gesamt,
                          ),
                        )}
                      </td>
                    </>
                  )}

                  {checkBox_3 && (
                    <>
                      <td className="planning_table_total_child">
                        {formatGermanFixedBy2(
                          istTotals?.kollektionAbwPercentagePlan,
                        ) || ""}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanFixedBy2(totals?.nosVororderPct) || ""}
                      </td>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(
                          Math.round(totals?.nosVororderWert),
                        )}
                        {/* </div> */}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanFixedBy2(totals?.nosNachorderPct) || ""}
                      </td>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(
                          Math.round(totals?.nosNachorderWert),
                        )}
                        {/* </div> */}
                      </td>
                      <td className="planning_table_total_child">
                        {/* <div className="planning_table_total_child-inside"> */}
                        {formatGermanInputForDecimal(
                          Math.round(totals?.nosVororderWert) +
                            Math.round(totals?.nosNachorderWert),
                        )}
                        {/* </div> */}
                      </td>
                    </>
                  )}

                  {checkBox_9 && (
                    <td className="planning_table_total_child unused"></td>
                  )}

                  {checkBox_6 && (
                    <>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          Math.round(istTotals?.EKLimitpro_NOSIstVOWertAS400),
                        )}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          Math.round(istTotals?.EKLimitpro_NOSIstREOWertAS400),
                        )}
                      </td>
                      <td className="planning_table_total_child">
                        {formatGermanInputForDecimal(
                          istTotals?.EKlimitProNOSIstAs400Gesamt,
                        )}
                      </td>
                    </>
                  )}

                  {checkBox_3 && (
                    <td className="planning_table_total_child">
                      {formatGermanFixedBy2(istTotals?.NOSAbwPercentagePlan) ||
                        ""}
                    </td>
                  )}
                </>
              ) : null}

              {showAnfangsLagerGesamtVKSection && (
                <>
                  {showAnfangsLagerPlanWertColumn && (
                    <td className="planning_table_total_child unused">
                      {formatGermanInputForDecimal(
                        istTotals?.AnfangsLagPlanWert,
                      ) || ""}
                    </td>
                  )}

                  {showAnfangsLagerIstWertAS400Column && (
                    <td className="planning_table_total_child unused">
                      {formatGermanInputForDecimal(
                        istTotals?.AnfangsLagIstWertAS400,
                      ) || ""}
                    </td>
                  )}

                  {showAnfangsLagerAbwPlanColumn && (
                    <td className="planning_table_total_child unused">
                      {formatGermanInputForDecimal(
                        istTotals?.AnfangsLagAbwPercentagePlan,
                      ) || ""}
                    </td>
                  )}
                </>
              )}

              {showAbschriftenGesamtVKSection && (
                <>
                  {showAbschriftenAnteileColumn && (
                    <td className="planning_table_total_child">
                      {formatGermanFixedBy2(totals?.abschriftenAnteilePct) ||
                        ""}
                    </td>
                  )}

                  {showAbschriftenPlanWertColumn && (
                    <td className="planning_table_total_child">
                      {/* <div className="planning_table_total_child-inside"> */}
                      {formatGermanInputForDecimal(
                        Math.round(totals?.planWertAbschriftenGesamt),
                      )}
                      {/* </div> */}
                    </td>
                  )}

                  {showAbschriftenIstWertAS400Column && (
                    <td className="planning_table_total_child unused">
                      {istTotals?.Abschriften_GesamtIstWertAS400 || ""}
                    </td>
                  )}

                  {showAbschriftenAbwPlanColumn && (
                    <td className="planning_table_total_child unused">
                      {formatGermanFixedBy2(
                        istTotals?.AbschriftenGesamtAbwPercentagePlan,
                      ) || ""}
                    </td>
                  )}
                </>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlanningTableNew;
